import React, { useCallback, useMemo } from 'react';

import { DateService, useArchivedTournamentState } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

import { groupBy } from 'common/utils/groupBy';
import ResultsEventsListItem from 'components/Pages/Results/ResultsEvents/ResultsEventsListItem';

const ResultsEventsList = () => {
  const { events, loading } = useArchivedTournamentState();
  const sortedEvents = useMemo(() => {
    if (!events) return [];

    return Object.entries(groupBy(Object.values(events), 'startTime'))
      .sort(([dateA], [dateB]) => dateA - dateB)
      .map(([date, eventsOnDate]) => ({
        date: DateService.getFormattedDate(date),
        events: eventsOnDate,
      }));
  }, [events]);

  const renderEvents = useCallback(
    events =>
      Object.values(events).map(event => (
        <ResultsEventsListItem event={event} key={event.id} urlEventId={event.id} />
      )),
    [],
  );

  if (loading) {
    return (
      <div className="tournament-scroll-event-info result">
        <div className="menu-item-container">
          <div className="skeleton-event">
            <div className="skeleton-participants">
              <div className="title-line-1 skeleton" />
              <div className="title-line-2 skeleton" />
              <div className="title-line-2 skeleton" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (events !== null && events.length === 0) {
    return (
      <EmptyStateView
        className="results-tournament-empty-state"
        description="results_empty_tournament_message"
        title="results_empty_tournament_title"
      />
    );
  }

  return <>{sortedEvents.map(({ events }) => renderEvents(events))}</>;
};

export default ResultsEventsList;
